<template>
  <Lottie
    id="map-netherlands"
    class="animation"
    :options="mapAnimationOptions"
  />
</template>

<script>
import Lottie from 'chimera/all/components/Lottie'
import { getWithText } from 'chimera/all/assets/lottie/maps/netherlands.js'

export default {
  name: 'MapNetherlands',

  components: {
    Lottie,
  },

  props: {
    text: {
      type: String,
      default: 'heeft een specialist nodig',
    },
  },

  computed: {
    /**
     *
     * @returns {{animationData: *}}
     */
    mapAnimationOptions() {
      return {
        animationData: getWithText(this.text),
      }
    },
  },
}
</script>
